/**
 * Hearth's own line icons — 24px grid, 1.6px strokes, rounded joins. Drawn for
 * this product rather than pulled from a stock set.
 */
import type { SVGProps } from 'react';
import { Logogram } from './Brand.tsx';

const P: Record<string, string> = {
  today: 'M4 10.5 12 4l8 6.5M6.5 9v10.5h11V9M10 19.5v-5h4v5',
  people: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2.8 20c.6-3.4 3.2-5.6 6.2-5.6s5.6 2.2 6.2 5.6M16 4.4a3.3 3.3 0 0 1 0 6.3M18.2 14.6c1.7.8 2.8 2.7 3.1 5.4',
  org: 'M12 3.5v5M5.5 15.5V12h13v3.5M12 8.5v3.5M9.5 3.5h5v5h-5zM3 15.5h5v5H3zM9.5 15.5h5v5h-5zM16 15.5h5v5h-5z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5.2l3.4 2',
  roster: 'M3.5 6.5h17v13h-17zM3.5 10.5h17M8 3.5v5M16 3.5v5M7 14h2M11 14h2M15 14h2M7 17h2M11 17h2',
  face: 'M8 3.5H5.5a2 2 0 0 0-2 2V8M16 3.5h2.5a2 2 0 0 1 2 2V8M8 20.5H5.5a2 2 0 0 1-2-2V16M16 20.5h2.5a2 2 0 0 0 2-2V16M9 10v.5M15 10v.5M12 10v3.5h-1M9.5 16.2c1.4 1 3.6 1 5 0',
  inbox: 'M3.5 13.5 6 5h12l2.5 8.5M3.5 13.5V19h17v-5.5M3.5 13.5h5l1.2 2.2h4.6l1.2-2.2h5',
  wallet: 'M4 7.5h14.5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2H16M16 14h2.5',
  formula: 'M6 19c2 0 2.4-1.6 2.8-4l1.4-7c.5-2.5 1.1-4 3.3-4M7 9.5h7M14 13.5l5 5M19 13.5l-5 5',
  sliders: 'M4 7h9M17 7h3M4 17h3M11 17h9M15 4.5v5M9 14.5v5',
  fingerprint: 'M6.3 7.2A7.5 7.5 0 0 1 19.5 12c0 2-.2 3.6-.7 5M4.5 12c0-.9.2-1.8.5-2.6M8 18.8c.8-2 1.2-4.3 1.2-6.8a2.8 2.8 0 0 1 5.6 0c0 1.2-.1 2.3-.3 3.4M12 12c0 3.4-.7 6.3-2 8.6M15.6 18.6l-.6 1.9',
  key: 'M14.5 13a5 5 0 1 0-4.6-3L3.5 16.4V20H7l.5-1.5H9V17h1.5l1.6-1.6A5 5 0 0 0 14.5 13ZM16 7.5h.01',
  scroll: 'M7 3.5h10.5a2 2 0 0 1 2 2V8H17M7 3.5a2 2 0 0 0-2 2V18a2.5 2.5 0 0 0 2.5 2.5h9A2.5 2.5 0 0 0 19 18v-1.5H9.5V18a2.5 2.5 0 0 1-2.5 2.5M7 3.5a2 2 0 0 1 2 2V16.5M11.5 8.5h3.5M11.5 12h3.5',
  canteen: 'M6 3.5v6.5a2 2 0 0 0 2 2M10 3.5v6.5a2 2 0 0 1-2 2v8.5M8 3.5v5M16.5 20.5v-17c-2 1-3 3.5-3 6.5v4h3',
  coins: 'M9 10.5c3 0 5.5-1.1 5.5-2.5S12 5.5 9 5.5 3.5 6.6 3.5 8 6 10.5 9 10.5ZM3.5 8v4c0 1.4 2.5 2.5 5.5 2.5M3.5 12v4c0 1.4 2.5 2.5 5.5 2.5M14.5 12.8c3.1 0 6-1 6-2.3M20.5 10.5v6c0 1.4-2.6 2.5-5.8 2.5s-5.7-1.1-5.7-2.5v-6M9 10.5c0-1.3 2.6-2.3 5.8-2.3',
  search: 'M10.8 18a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM16.2 16.2 20.5 20.5',
  plus: 'M12 5v14M5 12h14',
  chevronRight: 'm9.5 6 6 6-6 6',
  chevronDown: 'm6 9.5 6 6 6-6',
  chevronLeft: 'm14.5 6-6 6 6 6',
  x: 'M6 6l12 12M18 6 6 18',
  check: 'm5 12.5 4.5 4.5L19 7.5',
  alert: 'M12 4 2.8 19.5h18.4L12 4ZM12 10v4.2M12 17h.01',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 11v5.5M12 7.7h.01',
  arrowUpRight: 'M7 17 17 7M8.5 7H17v8.5',
  arrowRight: 'M4.5 12h15M13.5 6l6 6-6 6',
  sun: 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4',
  moon: 'M19.5 14.8A8 8 0 0 1 9.2 4.5a8 8 0 1 0 10.3 10.3Z',
  logout: 'M14 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H14M10.5 12h10M17 8.5l3.5 3.5-3.5 3.5',
  filter: 'M3.5 5.5h17M6.5 12h11M10 18.5h4',
  download: 'M12 4v11M7 10.5l5 5 5-5M4.5 19.5h15',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12ZM12 14.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6Z',
  lock: 'M6 10.5h12v10H6zM8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3M12 14.5v2.5',
  pin: 'M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11ZM12 12.3a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6Z',
  camera: 'M4 7.5h3l1.6-2.5h6.8L17 7.5h3v12H4zM12 16.8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
  spark: 'M12 3c.5 4.6 2.4 6.5 7 7-4.6.5-6.5 2.4-7 7-.5-4.6-2.4-6.5-7-7 4.6-.5 6.5-2.4 7-7ZM19 16.5c.2 1.6.9 2.3 2.5 2.5-1.6.2-2.3.9-2.5 2.5-.2-1.6-.9-2.3-2.5-2.5 1.6-.2 2.3-.9 2.5-2.5Z',
  menu: 'M4 7h16M4 12h10M4 17h16',
  user: 'M12 11.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20.5c.8-4 3.8-6.3 7.5-6.3s6.7 2.3 7.5 6.3',
  file: 'M13.5 3.5H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9M13.5 3.5 19 9M13.5 3.5V9H19M8.5 13h7M8.5 16.5h4.5',
  building: 'M4.5 20.5V5.5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v15M15.5 10h2a2 2 0 0 1 2 2v8.5M3 20.5h18M8 7.5h1M11 7.5h1M8 11h1M11 11h1M8 14.5h1M11 14.5h1',
  refresh: 'M19.5 12a7.5 7.5 0 0 1-13.3 4.7M4.5 12a7.5 7.5 0 0 1 13.3-4.7M18 3.5v4h-4M6 20.5v-4h4',
  more: 'M5.5 12h.01M12 12h.01M18.5 12h.01',
  bank: 'M3.5 9 12 4l8.5 5M5 9.5v7M9.5 9.5v7M14.5 9.5v7M19 9.5v7M3.5 19.5h17',
  shield: 'M12 3.5 5 6.2v5.3c0 4.3 2.9 7.6 7 9 4.1-1.4 7-4.7 7-9V6.2L12 3.5ZM9 12l2.2 2.2 4-4.2',
  bolt: 'M13 3 5.5 13.5h5L10 21l8-11h-5.2L13 3Z',
  box: 'M12 3.5 20 7.5v9L12 20.5 4 16.5v-9L12 3.5ZM4 7.5l8 4 8-4M12 11.5v9',
  tag: 'M3.5 12.6V4.5a1 1 0 0 1 1-1h8.1l7.9 7.9a1.4 1.4 0 0 1 0 2l-6.1 6.1a1.4 1.4 0 0 1-2 0l-7.9-7.9ZM8 8h.01',
  paperclip: 'M19.5 11.2 12 18.7a4.6 4.6 0 0 1-6.5-6.5l7.6-7.6a3 3 0 0 1 4.3 4.3L9.8 16.5a1.5 1.5 0 0 1-2.1-2.1l7-7',
  link: 'M10 14a4 4 0 0 0 5.7 0l3.1-3.1a4 4 0 0 0-5.7-5.7L11.6 6.7M14 10a4 4 0 0 0-5.7 0l-3.1 3.1a4 4 0 0 0 5.7 5.7l1.5-1.5',
  percent: 'M18.5 5.5l-13 13M7.5 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16.5 18.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  bell: 'M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15L6 16.5ZM10 20.5a2.3 2.3 0 0 0 4 0',
  /** iOS Safari's Share button, for the Add to Home Screen steps. */
  share: 'M8.5 9.5h-2v11h11v-11h-2M12 3.5v11M8.5 7 12 3.5 15.5 7',
};

export type IconName = keyof typeof P;

export function Icon({ name, size, ...rest }: { name: IconName; size?: number } & Omit<SVGProps<SVGSVGElement>, 'name'>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={P[name]} />
    </svg>
  );
}

/** The GlobalXtreme logogram, inked in the current text colour (the full lockup is BrandLockup in Brand.tsx). */
export function BrandMark({ className }: { className?: string }) {
  return <Logogram className={className} />;
}
